<div class="card m-0 p-2 pb-0">
  <div class="col-12 m-0 p-0">
    <div class="p-formgrid grid p-fluid m-0 p-0">
      <h5 class="mt-2">
        Produit de référence
        <span *ngIf="!showResume">
          {{ ouvrage.CodeProjet }} : {{ ouvrage.BaseArticle?.TitreWEB }}
        </span>
      </h5>
      <a
        href="#"
        class="button_reduction float-end"
        (click)="displayResume($event)"
      >
        <i class="pi pi-bars"></i>
      </a>

      <div class="p-fluid p-formgrid grid" *ngIf="showResume">
        <div class="field col-3 custom_padding">
          <label htmlFor="titre"><b>Titre</b></label>
          <p>{{ ouvrage.BaseArticle?.TitreWEB }}</p>
        </div>

        <div class="field col-3 custom_padding">
          <label htmlFor="codearticle"><b>Code article</b></label>
          <p>{{ ouvrage.BaseArticle?.CodeArticle }}</p>
        </div>

        <div class="field col-3 custom_padding">
          <label htmlFor="EAN"><b>EAN</b></label>
          <p>{{ ouvrage.BaseArticle?.EAN }}</p>
        </div>

        <div class="field col-3 custom_padding">
          <label htmlFor="CodeOeuvre"><b>Code œuvre</b></label>

          <p>{{ ouvrage.BaseArticle?.CodeOeuvre }}</p>
        </div>

        <div class="field col-3 custom_padding">
          <label htmlFor="Statut"><b>Statut</b></label>

          <p>
            {{
              this.getOptionsLabel(
                "StatutArticle",
                ouvrage.BaseArticle?.StatutArticle
              )
            }}
          </p>
        </div>

        <div class="field col-3 custom_padding">
          <label htmlFor="Support"><b>Support</b></label>
          <p>
            {{ this.getOptionsLabel("Support", ouvrage.BaseArticle?.Support) }}
          </p>
        </div>

        <div class="field col-3 custom_padding">
          <label htmlFor="Collection"><b>Collection</b></label>

          <p>{{ ouvrage.BaseArticle?.CollectionEdito_search }}</p>
        </div>

        <div class="field col-3 custom_padding">
          <label htmlFor="DateParution"><b>Date de mise en vente</b></label>

          <p>{{ ouvrage.BaseArticle?.DateParution | date: "dd/MM/yyyy" }}</p>
        </div>

        <div class="field col-3 custom_padding">
          <label htmlFor="Matière(s)"><b>Matière(s)</b></label>

          <p>{{ getLabelValues(ouvrage.BaseArticle?.Matieres, "Matieres") }}</p>
        </div>

        <div class="field col-3 custom_padding">
          <label htmlFor="Classe"><b>Classe(s)</b></label>

          <p>{{ getLabelValues(ouvrage.BaseArticle?.Classe, "Classe") }}</p>
        </div>

        <div class="field col-3 custom_padding">
          <label htmlFor="Assistant"><b>Assistant d'édition</b></label>

          <p>{{ this.intervenant }}</p>
        </div>

        <div class="field col-3 custom_padding">
          <label htmlFor="Editeur"><b>Éditeur</b></label>
          <p>
            {{
              this.getOptionsLabel(
                "EditeurInterne",
                ouvrage.BaseArticle?.EditeurInterne
              )
            }}
          </p>
        </div>


        <div class="field col-3 custom_padding">
          <label htmlFor="OuvrageReforme"><b>Ouvrage réforme</b></label>
          <br>
          <input
            id="OuvrageReforme"
            type="checkbox"
            [disabled]="ouvrage.statut !== '0'"
            [checked]="ouvrage.ouvrage_reforme"
            (change)="updateOuvrage($event, 'OuvrageReforme', 'checkbox')"
          />
        </div>

        <div class="field col-3 custom_padding">
          <label htmlFor="CodeProjet"><b>Code projet</b></label>
          <input
            pInputText
            id="CodeProjet"
            type="text"
            [disabled]="ouvrage.statut !== '0'"
            [value]="ouvrage.CodeProjet"
            (change)="updateOuvrage($event, 'CodeProjet')"
          />
        </div>

        <div class="field col-3">
          <button
            pButton
            class="red-btn"
            style="margin-top: 9px; width: auto"
            *ngIf="userService.canEdit()"
            [disabled]="!isButtonEnabled()"
            (click)="onValidateButtonClick()"
          >
            <span *ngIf="ouvrage.statut === '0'"
              >Verrouiller</span
            >
            <span *ngIf="ouvrage.statut === '1'"
              >Finaliser le projet</span
            >
            <span *ngIf="ouvrage.statut === '2' && !userService.isSuperCem()"
              >Finaliser le projet</span
            >
            <span *ngIf="ouvrage.statut === '2' && userService.isSuperCem()"
              >Déverrouiller le projet</span
            >
          </button>
        </div>


        <div class="col-12">
          <p-steps
            [model]="steps"
            styleClass="mt-5"
            [readonly]="true"
            [activeIndex]="activeStep"
          ></p-steps>
        </div>
      </div>

      <div *ngFor="let error of errors">
        <p-message severity="error" text="{{ error }}"></p-message>
      </div>
      <div *ngIf="successMessage != ''">
        <p-message severity="success" text="{{ successMessage }}"></p-message>
      </div>
    </div>
  </div>
</div>

<p-toast key="cp_update"></p-toast>
<p-confirmDialog [style]="{width: '450px'}"></p-confirmDialog>
